<template>
  <v-btn
    small
    text
    @click="onClick"
    class="text-center"
  >
    <slot></slot>
    <div ref="printFrame" id="printFrame"></div>
  </v-btn>
</template>

<script>
import {
  VBtn,
} from 'vuetify/lib'
export default {
  components: {
    VBtn,
  },
  methods: {
    onClick() {
      const previousIFrame = document.getElementById('printable-frame')

      if (previousIFrame) {
        previousIFrame.remove()
      }

      const iframe = document.createElement('iframe')
      const printFrame = this.$refs.printFrame
      const elements = document.getElementsByClassName('print-me')
      let innerHTML = ''

      for (let i = 0; i < elements.length; i++) {
        innerHTML += elements[i].innerHTML
      }

      iframe.id = 'printable-frame'
      iframe.srcdoc = `
        <html>
          <head>
            <link href="https://fonts.googleapis.com/css2?family=Karla&family=Fredericka+the+Great&family=Nanum+Myeongjo:wght@700" rel="stylesheet">
            <style type=""text/css>
              body {
                font-family: 'Karla', sans-serif;
                font-size: 15px;
              }

              h1 {
                font-family: 'Nanum Myeongjo', serif;
                font-size: 30px;
                text-align: center;
              }

              .brand {
                font-family: 'Fredericka the Great', cursive;
                font-size: 15px;
                text-align: center;
              }

              .posted-on {
                display: none;
              }

              .print-link {
                margin-top: 80px;
                text-align: center;
              }
            </style>
          </head>
          <body>
            <p class="brand">CHEF NATURELLE</p>
            <div>
              ${innerHTML}
            </div>
            <p class="print-link">
              <a
                href="${window.location.href}"
                target="_blank"
              >
                ${window.location.href}
              </a>
            </p>
          </body>
        </html>
      `
      iframe.setAttribute('frameborder', 0)
      iframe.setAttribute('width', 0)
      iframe.setAttribute('height', 0)
      iframe.style.visibility = 'hidden'
      iframe.style.left = '-1px'

      printFrame.appendChild(iframe)

      iframe.onload = () => {
        iframe.focus()
        iframe.contentWindow.print()
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.printFrame {
  display: none;
}
</style>
